module.exports = function (turboName) {
  return (target, key, descriptor) => {
    if (window.requestAnimationFrame) {
      target.prototype[turboName] = requestAnimationFrame.bind(window);
      return;
    }

    target.prototype[turboName] = fn => {
      setTimeout(fn, 17);
    };
  };
};



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/checkRequestAnimationFrame.js